import {
  CargosCandidaturasGerenciamentoView,
  ComissaoEleitoralGerenciamentoView,
  EleicaoFormView,
  EleicaoView,
  EleicoesView,
  EleitoresGerenciamentoView,
  GrupoEleitoresFormView,
  GruposEleitoresView,
  PaginaInicialView,
} from '../views';
import { PublicAccessOnly, RequireAuth } from '../helpers';
import React, { FunctionComponent, useEffect } from 'react';
import { Route, Routes, matchPath, useLocation } from 'react-router-dom';

import { FaHome } from 'react-icons/fa';
import ForceReRenderProvider from '../contexts/ForceReRenderProvider';
import { PaginaNaoEncontradaView } from '../views/PaginaNaoEncontradaView';
import { RouteType } from '../types';
import { RouterErrorBoundary } from '../components/error';
import { TipoGrupoEleitoresEnum } from '../enums';
import { useTranslation } from 'react-i18next';

export const routes: RouteType[] = [
  {
    element: (
      <PublicAccessOnly>
        <PaginaInicialView />
      </PublicAccessOnly>
    ),
    path: '/',
    translationTag: 'rotas.pagina_inicial',
  },
  {
    breadcrumbsIcon: <FaHome className="mb-1 me-1" />,
    element: (
      <RequireAuth>
        <EleicoesView />
      </RequireAuth>
    ),
    path: '/eleicoes',
    translationTag: 'rotas.pagina_inicial',
  },
  {
    element: (
      <RequireAuth>
        <EleicaoFormView />
      </RequireAuth>
    ),
    path: '/eleicoes/cadastrar',
    translationTag: 'rotas.cadastrar_eleicao',
  },
  {
    element: (
      <RequireAuth>
        <EleicaoFormView />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/alterar',
    translationTag: 'rotas.alterar_eleicao',
  },
  {
    element: (
      <RequireAuth>
        <EleicaoView />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao',
    translationTag: 'rotas.visualizar_eleicao',
  },
  {
    element: (
      <RequireAuth>
        <ComissaoEleitoralGerenciamentoView />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/membros/alterar',
    translationTag: 'rotas.gerenciar_comissao_eleitoral',
  },
  {
    element: (
      <RequireAuth>
        <ForceReRenderProvider>
          <CargosCandidaturasGerenciamentoView />
        </ForceReRenderProvider>
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/cargos-candidaturas/alterar',
    translationTag: 'rotas.gerenciar_cargos_candidaturas',
  },
  {
    element: (
      <RequireAuth>
        <GrupoEleitoresFormView />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/grupos-eleitores/cadastrar',
    translationTag: 'rotas.cadastrar_grupo_eleitores',
  },
  {
    element: (
      <RequireAuth>
        <GrupoEleitoresFormView />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/grupos-eleitores/:idGrupoEleitores/alterar',
    translationTag: 'rotas.alterar_grupo_eleitores',
  },
  {
    element: (
      <RequireAuth>
        <GruposEleitoresView />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/grupos-eleitores/alterar',
    translationTag: 'rotas.gerenciar_grupos_eleitores',
  },
  {
    element: (
      <RequireAuth>
        <EleitoresGerenciamentoView tipo={TipoGrupoEleitoresEnum.DISCENTE} />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/grupos-eleitores/alterar/:idGrupoEleitores/discentes',
    translationTag: 'rotas.gerenciar_eleitores_discentes',
  },
  {
    element: (
      <RequireAuth>
        <EleitoresGerenciamentoView tipo={TipoGrupoEleitoresEnum.TECNICO_ADMINISTRATIVO} />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/grupos-eleitores/alterar/:idGrupoEleitores/tecnicos',
    translationTag: 'rotas.gerenciar_eleitores_tecnicos',
  },
  {
    element: (
      <RequireAuth>
        <EleitoresGerenciamentoView tipo={TipoGrupoEleitoresEnum.DOCENTE} />
      </RequireAuth>
    ),
    path: '/eleicoes/:idEleicao/grupos-eleitores/alterar/:idGrupoEleitores/docentes',
    translationTag: 'rotas.gerenciar_eleitores_docentes',
  },
];

const AppRouter: FunctionComponent = (): JSX.Element => {
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
      const rota = routes.find((route) => matchPath(route, location.pathname));
      (window as any).gtag('event', 'page_view', {
        page_hash: location.hash,
        page_path: location.pathname,
        page_search: location.search,
        page_title: t(rota?.translationTag!),
      });
    }
  }, [location]);

  return (
    <RouterErrorBoundary key={location.pathname}>
      <Routes>
        {routes.map((route) => (
          <Route path={route.path} element={route.element} key={route.path} />
        ))}
        <Route path="*" element={<PaginaNaoEncontradaView />} />
      </Routes>
    </RouterErrorBoundary>
  );
};

export default AppRouter;
